export default "__VITE_ASSET__DqhtbmNO__"